import React from 'react';
import { useI18n } from '../../contexts/I18nContext';
import { combinedState } from '../../lib/movement';
import { MV, HATCH, viewTone } from '../../lib/movementView';
import { DayBar } from './DayBar';

const WORD = { moving: 'mvd_moving', rest: 'mvd_resting', quiet: 'mvs_short_quiet', sensor: 'mvd_nosignal', nodata: 'mvn_nodata' };
const DOT = { moving: MV.moving.dot, rest: MV.rest.bar, quiet: MV.quiet.dot };

// Colour dot + one word + mini 24 h bar, for list rows.
export function MovementInline({ devices, buckets, policy, testid = 'movement-inline' }) {
  const { t } = useI18n();
  const tone = viewTone(combinedState(devices));
  return (
    <div className="flex items-center gap-3 min-w-0" data-testid={testid} data-tone={tone}>
      <span className="inline-flex items-center gap-1.5 text-xs font-medium text-ink shrink-0">
        <span className="w-2.5 h-2.5 rounded-full" style={{ background: DOT[tone] || HATCH, boxShadow: tone === 'rest' ? `inset 0 0 0 1px ${MV.rest.dot}` : 'none' }} />
        <span style={{ color: tone === 'quiet' ? MV.quiet.text : undefined }} data-testid={`${testid}-word`}>{t(WORD[tone])}</span>
      </span>
      <div className="w-28 sm:w-40 shrink-0">
        {buckets ? <DayBar buckets={buckets} ids={devices.map((d) => d.device_uuid)} policy={policy} compact testid={`${testid}-bar`} /> : <div className="h-2.5 rounded-md bg-bg-alt" />}
      </div>
    </div>
  );
}
